@if (component) {
<div class="flex flex-justify-center">
    <div [style.maxWidth.px]="component.maxWidth || null"
         [gridColumnGap]="component.gap+'px'"
         [grid]="gridSize">
        @for (column of component.items; track $index) {
        <icms-outlet [name]="'Column'"
                     [allow]="outletOptions?.context === 'blog' ? ['cms-blog-component-more-stories', 'cms-blog-image-and-copy', 'cms-blog-images'] : []"
                     [components]="column.components"
                     class="inline-block va-t"
                     [fullHeight]="true"
                     [gridColumn]="column.size" />
        }
    </div>
</div>
}